export enum DirectionType {
  positive,
  negative,
  both
}



// WEBPACK FOOTER //
// ./src/app/models/enums/directiontype.ts